<template>
    <div id="wrapper" class="page">

        <div id="content-wrapper">
            <div class="container-fluid" style="overflow:auto; min-height: 700px;">
                <!-- <b-link href="#" @click.prevent="openModal">
            <i class="fas fa-plus mr-2"></i> Thêm
          </b-link>-->
                <div class="row" style="margin-left:1px;">
                    <!-- <button class="btn btn-info mb-2 mr-2" @click.prevent="openModal">
                        <i class="fas fa-plus"></i> Add
                    </button> -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" size="sm"
                        class="my-0 mt-1">
                    </b-pagination>
                    <p style="margin-top: 8px; margin-left: 3px; color: #027bff;">Total: {{ totalRows }}</p>
                    <div style="flex-grow: 1" class="text-center"></div>
                    <button v-if="bonus_ps_payment" class="btn btn-warning mb-2 mr-3" @click.prevent="openModalPayment">
                        <i class="fas fa-money-check pr-1"></i> Payment
                    </button>

                    <button v-if="!Reporting && bonus_ps_report" class="btn btn-success mb-2 mr-3"
                        @click.prevent="exportReport">
                        <i class="fas fa-file-excel pr-1"></i> Paid
                    </button>
                    <b-spinner v-if="Reporting && bonus_ps_report" variant="success mb-2 mr-3"
                        label="Spinning"></b-spinner>
                    <button v-if="!Reporting2 && bonus_ps_report" class="btn btn-success mb-2 mr-3"
                        @click.prevent="exportReport2">
                        <i class="fas fa-file-excel pr-1"></i> Report
                    </button>
                    <b-spinner v-if="Reporting2 && bonus_ps_report" variant="success mb-2 mr-3"
                        label="Spinning"></b-spinner>
                </div>
                <div class="row" style="margin-left:1px; height: 45px;">
                    <b-form-input class="mr-2 " style="flex-grow: 1; width:1px;" v-model="search"
                        placeholder="Search by Code, Project Name, EP, PM" @keydown.enter.prevent="queryItem"
                        size="md" />
                    <p class="mt-2 mr-2">Status: </p>
                    <b-form-group class="mb-2 mr-2">
                        <b-form-select v-model="searchBonus.status" @change="queryItem">

                            <b-form-select-option value="Acct_Created">Acct_Created</b-form-select-option>
                            <b-form-select-option value="PM-In Progress">PM-In Progress</b-form-select-option>

                            <b-form-select-option value="PM-Pending Approval">Pending Approval</b-form-select-option>
                            <b-form-select-option value="PM-Rejected">Rejected</b-form-select-option>
                            <b-form-select-option value="PM-Approved">Approved</b-form-select-option>
                            <b-form-select-option value="PM-Lock-In">Locked In</b-form-select-option>
                            <b-form-select-option value="PM-Lock-Out">Locked Out</b-form-select-option>
                            <b-form-select-option value="PM-Paid-In">Paid In</b-form-select-option>
                            <b-form-select-option value="PM-Paid-Out">Paid Out</b-form-select-option>
                            <b-form-select-option :value="null">All</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                    <button class="btn btn-secondary mb-2 mr-3 ml-2 " style="float:right; height: 37px; width: 93px;"
                        @click.prevent="queryItem">
                        <b-row> <i class="fas fa-search mt-1 mr-2 ml-3"> </i>
                            <p>Search</p>
                        </b-row>


                    </button>
                </div>
                <div class="row" style="margin-left:1px; height: 45px;">

                    <p class="mt-2 mr-2">Production House: </p>
                    <b-form-group class="mb-2 mr-2">
                        <b-form-select v-model="searchBonus.productionHouse" :options="optionsCompany"
                            @change="queryItem">

                        </b-form-select>
                    </b-form-group>
                    <p class="mt-2 mr-2">Approve by: </p>
                    <b-form-group class="mb-2 mr-2">
                        <b-form-select v-model="searchBonus.approveBy" :options="searchBonus.optionApprove"
                            @change="queryItem">
                            <b-form-select-option :value="null">All</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                    <p class="mt-2 mr-2">Shooting Day: </p>
                    <b-form-group class="mb-2 mr-2">
                        <b-form-select v-model="searchBonus.filterDate" :options="optionsKyBaoCao_Report3"
                            @change="changeDateFilter">
                            <b-form-select-option :value="null">Customize</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                    <p class="ml-2 mt-2 mr-2">From </p>
                    <b-form-group class=" mr-2">
                        <vue-datepicker-local style="width: 130px" v-model="searchBonus.from" :local="local" clearable
                            @confirm="changeDate" show-buttons format="DD/MM/YYYY" />
                        <!-- <my-date-picker v-model="searchBonus.from" placeholder="DD/MM/YYYY"></my-date-picker> -->
                    </b-form-group>
                    <p class="mt-2 mr-2">To</p>
                    <b-form-group class="mr-2">
                        <vue-datepicker-local style="width: 130px" v-model="searchBonus.to" :local="local" clearable
                            @confirm="changeDate" show-buttons format="DD/MM/YYYY" />
                        <!-- <my-date-picker v-model="searchBonus.to" placeholder="DD/MM/YYYY"></my-date-picker> -->
                    </b-form-group>
                </div>
                <b-table :current-page="currentPage" :per-page="perPage" @filtered="onFiltered" bordered
                    head-variant="dark" hover responsive striped small table-variant="light" :fields="fields"
                    :items="items">


                    <template #cell(ep)="data">
                        <div class="text-left">
                            <p> {{ convertName(data.item.ep) }}</p>

                        </div>

                    </template>
                    <template #cell(pm)="data">
                        <div class="text-left">
                            <p> {{ convertName(data.item.pm) }}</p>

                        </div>

                    </template>
                    <template #cell(pM_DateLock)="data">
                        {{ convertToMMYYYY2(data.item.pM_DateLock) }}
                    </template>
                    <template #cell(pmApprover)="data">
                        <div class="text-left">
                            <p> {{ convertName(data.item.pmApprover) }}</p>

                        </div>

                    </template>
                    <template #cell(status)="data">
                        <span v-if="data.item.status == 'PM-Lock-Out'">
                            <b-badge style="background-color: #008DDA; color:white;">Locked Out</b-badge>
                        </span>
                        <span v-else-if="data.item.status == 'PM-Lock-In'">
                            <b-badge style="background-color: #008DDA; color:white;">Locked In</b-badge>
                        </span>
                        <span v-else-if="data.item.status == 'PM-In Progress'">
                            <b-badge style="background-color: #fde897; color:black;">{{ data.item.status }}</b-badge>
                        </span>
                        <span v-else-if="data.item.status == 'EP-In Progress'">
                            <b-badge style="background-color: #fde897; color:black;">{{ data.item.status }}</b-badge>
                        </span>
                        <span v-else-if="data.item.status == 'PM-Pending Approval'">
                            <b-badge style="background-color: #ffc9d5; color:#5e1d23;">Pending Approval</b-badge>
                        </span>
                        <span v-else-if="data.item.status == 'PM-Rejected'">
                            <b-badge style="background-color: #808080; color:white">Rejected</b-badge>
                        </span>
                        <span v-else-if="data.item.status == 'PM-Approved'">
                            <b-badge style="background-color: #c5e0b3; color:#092101;">Approved</b-badge>
                        </span>
                        <span v-else-if="data.item.status == 'Acct_Created'">
                            <b-badge style="background-color: #f7cea0; color:#4c4976;">Acct_Created</b-badge>
                        </span>
                        <span v-else-if="data.item.status == 'PM-Paid-In'">
                            <b-badge style="background-color: #FF5F00; color:#FEFFD2;">Paid In</b-badge>
                        </span>
                        <span v-else-if="data.item.status == 'PM-Paid-Out'">
                            <b-badge style="background-color: #006769; color:white;">Paid Out</b-badge>
                        </span>
                        <span v-else> {{ data.item.status }}</span>
                    </template>

                    <template #cell(firstDay)="data">
                        {{ convertDate2(data.item.days) }}
                    </template>
                    <template #cell(lastDay)="data">
                        {{ convertDate(data.item.lastDay) }}
                    </template>



                    <template v-slot:cell(action)="data">
                        <b-link class="text-info mr-2" href="#" @click.prevent="data.toggleDetails">
                            <i class="fas fa-user-friends"></i>
                        </b-link>
                        <b-link class="text-primary mr-2" v-if="bonus_ps_edit || (bonus_ps_edit_approve && checkID(data.item.pmApprover)) || (bonus_ps_edit_pm && checkID(data.item.pm)) " href="#"
                            @click.prevent="openUpdateModal(data)">
                            <i class="fas fa-pencil-alt"></i>
                        </b-link>
                        <b-link class="text-success mr-2"
                            v-if="['PM-Pending Approval', 'PM-Approved'].includes(data.item.status) && data.item.pmApprover == $store.state.auth.accountId && bonus_ps_approve"
                            href="#" @click.prevent="approveRequest(data)">
                            <i class="fas fa-check-circle"></i>
                        </b-link>
                        <b-link class="text-secondary mr-2"
                            v-if="data.item.status == 'PM-In Progress' && (bonus_ps_submit_approve || bonus_ps_submit_approve_edit)"
                            href="#" @click.prevent="SendApprove(data.item)">
                            <i class="fa fa-paper-plane"></i>
                        </b-link>

                        <b-link
                            v-if="bonus_ps_lock && ['PM-Lock-In', 'PM-Approved', 'PM-Lock-Out'].includes(data.item.status)"
                            class=" mr-2" href="#" @click.prevent="lockProject(data)">
                            <span v-if="data.item.pmLock == true || data.item.pmLock == 'true'">
                                <i class="fas fa-lock text-warning"></i>
                            </span>
                            <span v-else>

                                <i class="fas fa-unlock text-primary"></i>
                            </span>
                        </b-link>

                        <!-- <b-link class="text-danger" href="#" v-if="bonus_ps_delete" @click.prevent="deleteItem(data)">
                            <i class="fas fa-trash"></i>
                        </b-link> -->
                        <!-- <button class="btn btn-info mr-1" @click="openUpdateModal(data)" v-if="meeting_udpate">
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button class="btn btn-danger" @click="deleteItem(data)" v-if="meeting_delete">
                <i class="fas fa-trash-alt"></i>
              </button>             -->
                    </template>
                    <template #row-details="row">
                        <b-card>
                            <div style="float: right;">
                                <button class="btn btn-danger mb-2 mr-1 ml-2 "
                                    style="float:right; height: 37px; width: 40px;" @click.prevent="row.toggleDetails">
                                    <b-row> <i class="fas fa-times mt-1 mr-2 ml-3"> </i>
                                        <!-- <p>Close</p> -->
                                    </b-row>
                                </button>
                            </div>
                            <hearder-model
                                v-if="row.item.employees.filter(e => (e.groupID == 10 || e.groupID == 4)).length"
                                style="margin-top: 40px;" value="Production"></hearder-model>
                            <!-- <div style="background-color: green; width: 100%; text-align: left;  color: white; margin-top: 40px;">
                                <b class="ml-1">Production </b>
                            </div> -->
                            <b-table v-if="row.item.employees.filter(e => (e.groupID == 10 || e.groupID == 4)).length"
                                head-variant="light !important" class="custom-table" :fields="fieldEmployee" striped
                                hover :items="row.item.employees.filter(e => (e.groupID == 10 || e.groupID == 4))">
                                <template v-slot:cell(username)="data">
                                    <div class="text-left ml-1">
                                        {{ convertName(data.item.userID) }}
                                    </div>
                                </template>
                                <template v-slot:cell(position)="data">
                                    <div class="text-left ml-1">
                                        {{ convertPosition(data.item.userID) }}
                                    </div>

                                </template>
                                <template v-slot:cell(frequency)="data">
                                    <div class="text-left ml-1">
                                        {{ data.item.frequency }}
                                    </div>

                                </template>
                                <template v-slot:cell(notes)="data">
                                    <div class="text-left ml-1">
                                        {{ data.item.notes }}
                                    </div>

                                </template>
                                <template v-slot:cell(bonus)="data">

                                    <span v-if="data.item.bonus > 0">
                                        {{ data.item.bonus | numeral('0,0') }}
                                    </span>
                                    <span v-else> - </span>
                                </template>
                            </b-table>
                            <hearder-model v-if="row.item.employees.filter(e => e.groupID == 5).length"
                                value="Additional Production Staff"></hearder-model>
                            <!-- <div style="background-color: green; width: 100%; text-align: left;  color: white;">
                                <b class="ml-1">Additional Production Staff</b>
                            </div> -->
                            <b-table v-if="row.item.employees.filter(e => e.groupID == 5).length"
                                head-variant="light !important" class="custom-table" :fields="fieldEmployee" striped
                                hover :items="row.item.employees.filter(e => e.groupID == 5)">
                                <template v-slot:cell(username)="data">
                                    <div class="text-left ml-1">
                                        {{ convertName(data.item.userID) }}
                                    </div>
                                </template>
                                <template v-slot:cell(position)="data">
                                    <div class="text-left ml-1">
                                        {{ convertPosition(data.item.userID) }}
                                    </div>

                                </template>
                                <template v-slot:cell(frequency)="data">
                                    <div class="text-left ml-1">
                                        {{ data.item.frequency }}
                                    </div>

                                </template>
                                <template v-slot:cell(notes)="data">
                                    <div class="text-left ml-1">
                                        {{ data.item.notes }}
                                    </div>

                                </template>
                                <template v-slot:cell(bonus)="data">

                                    <span v-if="data.item.bonus > 0">
                                        {{ data.item.bonus | numeral('0,0') }}
                                    </span>
                                    <span v-else> - </span>
                                </template>
                            </b-table>
                            <hearder-model v-if="row.item.employees.filter(e => e.groupID == 7).length"
                                value="Other"></hearder-model>

                            <b-table v-if="row.item.employees.filter(e => e.groupID == 7).length"
                                head-variant="light !important" class="custom-table" :fields="fieldEmployee" striped
                                hover :items="row.item.employees.filter(e => e.groupID == 7)">
                                <template v-slot:cell(username)="data">
                                    <div class="text-left ml-1">
                                        {{ convertName(data.item.userID) }}
                                    </div>
                                </template>
                                <template v-slot:cell(position)="data">
                                    <div class="text-left ml-1">
                                        {{ convertPosition(data.item.userID) }}
                                    </div>

                                </template>
                                <template v-slot:cell(frequency)="data">
                                    <div class="text-left ml-1">
                                        {{ data.item.frequency }}
                                    </div>

                                </template>
                                <template v-slot:cell(notes)="data">
                                    <div class="text-left ml-1">
                                        {{ data.item.notes }}
                                    </div>

                                </template>
                                <template v-slot:cell(bonus)="data">

                                    <span v-if="data.item.bonus > 0">
                                        {{ data.item.bonus | numeral('0,0') }}
                                    </span>
                                    <span v-else> - </span>
                                </template>
                            </b-table>
                            <hearder-model v-if="row.item.employees.filter(e => e.groupID == 8).length"
                                value="Director Pitching/ Treatment"></hearder-model>

                            <b-table v-if="row.item.employees.filter(e => e.groupID == 8).length"
                                head-variant="light !important" class="custom-table" :fields="fieldEmployee" striped
                                hover :items="row.item.employees.filter(e => e.groupID == 8)">
                                <template v-slot:cell(username)="data">
                                    <div class="text-left ml-1">
                                        {{ convertName(data.item.userID) }}
                                    </div>
                                </template>
                                <template v-slot:cell(position)="data">
                                    <div class="text-left ml-1">
                                        {{ convertPosition(data.item.userID) }}
                                    </div>

                                </template>
                                <template v-slot:cell(frequency)="data">
                                    <div class="text-left ml-1">
                                        {{ data.item.frequency }}
                                    </div>

                                </template>
                                <template v-slot:cell(notes)="data">
                                    <div class="text-left ml-1">
                                        {{ data.item.notes }}
                                    </div>

                                </template>
                                <template v-slot:cell(bonus)="data">

                                    <span v-if="data.item.bonus > 0">
                                        {{ data.item.bonus | numeral('0,0') }}
                                    </span>
                                    <span v-else> - </span>
                                </template>
                            </b-table>
                            <hearder-model v-if="row.item.employees.filter(e => e.groupID == 9).length"
                                value="Post Production"></hearder-model>

                            <b-table v-if="row.item.employees.filter(e => e.groupID == 9).length"
                                head-variant="light !important" class="custom-table" :fields="fieldEmployee" striped
                                hover :items="row.item.employees.filter(e => e.groupID == 9)">
                                <template v-slot:cell(username)="data">
                                    <div class="text-left ml-1">
                                        {{ convertName(data.item.userID) }}
                                    </div>
                                </template>
                                <template v-slot:cell(position)="data">
                                    <div class="text-left ml-1">
                                        {{ convertPosition(data.item.userID) }}
                                    </div>

                                </template>
                                <template v-slot:cell(frequency)="data">
                                    <div class="text-left ml-1">
                                        {{ data.item.frequency }}
                                    </div>

                                </template>
                                <template v-slot:cell(notes)="data">
                                    <div class="text-left ml-1">
                                        {{ data.item.notes }}
                                    </div>

                                </template>
                                <template v-slot:cell(bonus)="data">

                                    <span v-if="data.item.bonus > 0">
                                        {{ data.item.bonus | numeral('0,0') }}
                                    </span>
                                    <span v-else> - </span>
                                </template>
                            </b-table>
                        </b-card>
                    </template>
                </b-table>
            </div>
        </div>
        <b-modal v-model="modalShow" size="xl" header-bg-variant="info" header-text-variant="light">

            <template v-slot:modal-title>
                <div v-if="item.id <= 0">Add </div>
                <div v-else>Update </div>
            </template>

            <template v-slot:modal-footer="{ ok, cancel }">
                <div class="w-100">
                    <b-button v-if="item.status != 'Acct_Created'" class="float-left" variant="primary"
                        @click="PrintDetail()"><i class="fas fa-print mr-2 "></i>Print</b-button>
                    <b-button v-if="item.status == 'PM-Approved' && black_key" class="float-left ml-2" variant="dark"
                        @click="storeItem2()"><i class="fas fa-kiss-wink-heart mr-2 "></i>Test</b-button>
                    <b-button class="float-right mr-2" variant="info" @click="storeItem()"><i
                            class="fas fa-save mr-2"></i>Save</b-button>
                    <b-button class="float-right mr-2" variant="secondary" @click="cancel()"><i
                            class="fas fa-times mr-2"></i>Close</b-button>
                </div>
            </template>
            <b-container>
                <b-card no-body>
                    <b-tabs v-model="tabIndex" small card>

                        <b-tab>
                            <template #title>
                                <span style="font-size:16px"> Sales </span>
                            </template>

                            <b-row>
                                <b-col>
                                    <b-form-group>

                                        <template v-slot:label>
                                            Project Code
                                            <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input v-model="item.code" required :disabled="true"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group>

                                        <template v-slot:label>Production House Name <code>*</code> </template>
                                        <b-row>
                                            <b-col>
                                                <b-form-select :disabled="true" v-model="item.productionHouse"
                                                    class=" pt-0 pb-0" size="md" @input="updateProduction"
                                                    :options="optionsCompany" value-field="madonvi" text-field="madonvi"
                                                    oninvalid="this.setCustomValidity('Please enter Gender')"
                                                    oninput="setCustomValidity('')" required>
                                                </b-form-select>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group>

                                        <template v-slot:label>
                                            Client Name
                                            <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input :disabled="true" v-model="item.client" required></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group>

                                        <template v-slot:label>
                                            Project Name
                                            <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input :disabled="true" v-model="item.projectName"
                                            required></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group>

                                        <template v-slot:label>EP Name <code>*</code> </template>
                                        <b-row>
                                            <b-col>
                                                <multiselect :disabled="true" v-model="item.EP" track-by="name"
                                                    label="name" placeholder selectedLabel="are selecting"
                                                    select-label="Enter to select" deselectLabel="Enter to remove"
                                                    :searchable="true" :options="optionEP" @select="unlockHopitalCity"
                                                    @remove="lockHopitalCity">
                                                </multiselect>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group>

                                        <template v-slot:label>PM Name <code>*</code> </template>
                                        <b-row>
                                            <b-col>
                                                <multiselect :disabled="true" v-model="item.PM" placeholder
                                                    selectedLabel="are selecting" track-by="name" label="name"
                                                    select-label="Enter to select" deselectLabel="Enter to remove"
                                                    :searchable="true" :options="optionPM">
                                                </multiselect>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </b-col>
                            </b-row>


                        </b-tab>

                        <b-tab>
                            <template #title>
                                <span style="font-size:16px"> Shooting </span>
                            </template>
                            <b-row>
                                <b-col>
                                    <b-form-group>
                                        <template v-slot:label> Days of shooting <code>*</code> </template>
                                        <template>
                                            <b-row>

                                                <b-col cols="9">
                                                    <b-form-group>
                                                        <vue-datepicker-local style="width: 100%" v-model="tmpDay"
                                                            :local="local" clearable format="DD/MM/YYYY" />
                                                    </b-form-group>
                                                </b-col>

                                                <b-col>
                                                    <button class="btn btn-info float-right w-100"
                                                        @click.prevent="addNewDay">
                                                        <i class="fas fa-plus"></i> Add Day
                                                    </button>
                                                </b-col>

                                            </b-row>
                                            <b-row style="margin-top: 5px">
                                                <b-col>
                                                    <b-table head-variant="light" :fields="fieldWebsite" bordered hover
                                                        responsive striped small table-variant="light"
                                                        :items="item.daysOfShooting">
                                                        <template v-slot:cell(day)="data">
                                                            <div class="truncate-text ">
                                                                {{ convertToMMYYYY(data.item.day) }}
                                                            </div>
                                                        </template>
                                                        <template #cell(index)="data">
                                                            <div class="text-center">
                                                                {{ data.index + 1 }}
                                                            </div>

                                                        </template>
                                                        <template v-slot:cell(action)="data">
                                                            <div>
                                                                <div class="float-right">
                                                                    <b-link class="text-danger" href="#"
                                                                        @click.prevent="deleteDay(data)">
                                                                        <i class="fas fa-trash"></i>
                                                                    </b-link>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </b-table>
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col>
                                                    <b-form-group>

                                                        <template v-slot:label>Day of Master Delivery <code>*</code>
                                                            :</template>
                                                        <b-row>
                                                            <b-col>
                                                                <vue-datepicker-local style="width: 100%"
                                                                    v-model="item.dayOfMasterDelivery" :local="local"
                                                                    clearable format="DD/MM/YYYY" />
                                                            </b-col>
                                                        </b-row>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>
                                                    <b-form-group>

                                                        <template v-slot:label>Approved by <code>*</code> :</template>
                                                        <b-row>
                                                            <b-col>
                                                                <multiselect v-model="item.PMApprover" placeholder
                                                                    selectedLabel="are selecting" track-by="hovaten"
                                                                    label="hovaten" select-label="Enter to select"
                                                                    deselectLabel="Enter to remove" :searchable="true"
                                                                    :options="postApprove2">
                                                                </multiselect>
                                                            </b-col>
                                                        </b-row>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row style="margin-top: 5px">
                                                <b-col>
                                                    <b-form-group>
                                                        <template v-slot:label>
                                                            <Header value="Production"></Header>
                                                            <!-- <div
                                                                style="background-color: green; width: 100%; text-align: left;  color: white;">
                                                                <b class="ml-1">Production</b>
                                                            </div> -->
                                                        </template>
                                                        <b-table head-variant="light" :fields="fieldTemplate" bordered
                                                            hover responsive striped small table-variant="light"
                                                            :items="item.employee1">
                                                            <template v-slot:cell(company)="data">
                                                                <div class="truncate-text">
                                                                    <b-form-select
                                                                        v-model="item.employee1[data.index].company"
                                                                        :disabled="true" class=" pt-0 pb-0" size="md"
                                                                        :options="optionsCompany" value-field="madonvi"
                                                                        text-field="madonvi"
                                                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                                                        oninput="setCustomValidity('')" required>
                                                                    </b-form-select>
                                                                </div>
                                                            </template>
                                                            <template #cell(Content)="data">
                                                                <div class="text-center">
                                                                    {{ data.content }}
                                                                </div>

                                                            </template>

                                                            <template v-slot:cell(name)="data">
                                                                <div class="truncate-text">
                                                                    <!-- <multiselect v-model="item.employee1[data.index].user"
                                                                    placeholder selectedLabel="are selecting"
                                                                    track-by="name" label="name"
                                                                    select-label="Enter to select"
                                                                    deselectLabel="Enter to remove" :searchable="true"
                                                                    :options="item.employee1[data.index].option">
                                                                </multiselect> -->
                                                                    <b-form-select
                                                                        @input="onInputUser2(data.index, item.employee1)"
                                                                        v-model="item.employee1[data.index].user"
                                                                        class=" pt-0 pb-0" size="md"
                                                                        :options="returnOption(data.index)"
                                                                        value-field="id" text-field="name"
                                                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                                                        oninput="setCustomValidity('')" required>
                                                                        <b-form-select-option
                                                                            :value="null"></b-form-select-option>
                                                                    </b-form-select>
                                                                </div>
                                                            </template>
                                                            <template #cell(frequency)="data">
                                                                <div class="text-center">
                                                                    <b-form-input style="text-align: right;"
                                                                        :disabled="item.employee1[data.index].typeFrequency == 'Project'"
                                                                        v-model="item.employee1[data.index].frequency"
                                                                        id="textarea-auto-height" placeholder=""
                                                                        type="number"> </b-form-input>
                                                                    <!-- <my-currency-input v-model="item.employee1[data.index].frequency" /> -->
                                                                </div>

                                                            </template>
                                                            <template #cell(notes)="data">
                                                                <div class="text-center">
                                                                    <b-form-input
                                                                        v-model="item.employee1[data.index].notes"></b-form-input>

                                                                </div>

                                                            </template>
                                                            <!-- <template v-slot:cell(action)="data">
                                                            <div>
                                                                <div class="float-right">
                                                                    <b-link class="text-danger" href="#"
                                                                        @click.prevent="deleteDay(data)">
                                                                        <i class="fas fa-trash"></i>
                                                                    </b-link>
                                                                </div>
                                                            </div>
                                                        </template> -->
                                                        </b-table>
                                                    </b-form-group>
                                                </b-col>

                                            </b-row>
                                            <b-row style="margin-top: 5px">
                                                <b-col>
                                                    <b-form-group>
                                                        <template v-slot:label>
                                                            <Header value="Additional Production Staff"></Header>
                                                            <!-- <div
                                                                style="background-color: green; width: 100%; text-align: left;  color: white;">
                                                                <b class="ml-1">Additional Production Staff</b>
                                                            </div> -->

                                                        </template>
                                                        <b-table head-variant="light" :fields="fieldTemplate" bordered
                                                            hover responsive striped small table-variant="light"
                                                            :items="item.employee2">
                                                            <template v-slot:cell(company)="data">
                                                                <div class="truncate-text">
                                                                    <b-form-select
                                                                        v-model="item.employee2[data.index].company"
                                                                        @input="onChangeCompany(data.index, item.employee2)"
                                                                        class=" pt-0 pb-0" size="md"
                                                                        :options="optionsCompany"
                                                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                                                        oninput="setCustomValidity('')" required>
                                                                    </b-form-select>
                                                                </div>
                                                            </template>
                                                            <template #cell(Content)="data">
                                                                <div class="text-center">
                                                                    {{ data.content }}
                                                                </div>

                                                            </template>

                                                            <template v-slot:cell(name)="data">
                                                                <div class="truncate-text">
                                                                    <!-- <multiselect v-model="item.employee1[data.index].user"
                                                                    placeholder selectedLabel="are selecting"
                                                                    track-by="name" label="name"
                                                                    select-label="Enter to select"
                                                                    deselectLabel="Enter to remove" :searchable="true"
                                                                    :options="item.employee1[data.index].option">
                                                                </multiselect> -->
                                                                    <b-form-select
                                                                        @input="onInputUser(data.index, item.employee2)"
                                                                        v-model="item.employee2[data.index].user"
                                                                        class=" pt-0 pb-0" size="md"
                                                                        :options="item.employee2[data.index].option"
                                                                        value-field="id" text-field="name"
                                                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                                                        oninput="setCustomValidity('')" required>
                                                                        <b-form-select-option
                                                                            :value="null"></b-form-select-option>
                                                                    </b-form-select>
                                                                </div>
                                                            </template>
                                                            <template #cell(frequency)="data">
                                                                <div class="text-center">
                                                                    <b-form-input style="text-align: right;"
                                                                        :disabled="item.employee2[data.index].typeFrequency == 'Project'"
                                                                        v-model="item.employee2[data.index].frequency"
                                                                        id="textarea-auto-height" placeholder=""
                                                                        type="number">
                                                                    </b-form-input>
                                                                    <!-- <my-currency-input v-model="item.employee2[data.index].frequency" /> -->
                                                                </div>

                                                            </template>
                                                            <template #cell(notes)="data">
                                                                <div class="text-center">
                                                                    <b-form-input
                                                                        v-model="item.employee2[data.index].notes"></b-form-input>

                                                                </div>

                                                            </template>
                                                            <!-- <template v-slot:cell(action)="data">
                                                            <div>
                                                                <div class="float-right">
                                                                    <b-link class="text-danger" href="#"
                                                                        @click.prevent="deleteDay(data)">
                                                                        <i class="fas fa-trash"></i>
                                                                    </b-link>
                                                                </div>
                                                            </div>
                                                        </template> -->
                                                        </b-table>

                                                    </b-form-group>

                                                </b-col>
                                            </b-row>
                                            <b-row style="margin-top: 5px">
                                                <b-col>
                                                    <b-form-group>
                                                        <template v-slot:label>
                                                            <Header value="Other"></Header>
                                                            <!-- <div
                                                                style="background-color: green; width: 100%; text-align: left;  color: white;">
                                                                <b class="ml-1">Other</b>
                                                            </div> -->
                                                        </template>
                                                        <b-table head-variant="light" :fields="fieldTemplate" bordered
                                                            hover responsive striped small table-variant="light"
                                                            :items="item.employee3">
                                                            <template v-slot:cell(company)="data">
                                                                <div class="truncate-text">
                                                                    <b-form-select
                                                                        v-model="item.employee3[data.index].company"
                                                                        @input="onChangeCompany(data.index, item.employee3)"
                                                                        class=" pt-0 pb-0" size="md"
                                                                        :options="optionsCompany"
                                                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                                                        oninput="setCustomValidity('')" required>
                                                                    </b-form-select>
                                                                </div>
                                                            </template>
                                                            <template #cell(Content)="data">
                                                                <div class="text-center">
                                                                    {{ data.content }}
                                                                </div>

                                                            </template>

                                                            <template v-slot:cell(name)="data">
                                                                <div class="truncate-text">
                                                                    <b-form-select
                                                                        @input="onInputUser(data.index, item.employee3)"
                                                                        v-model="item.employee3[data.index].user"
                                                                        class=" pt-0 pb-0" size="md"
                                                                        :options="item.employee3[data.index].option"
                                                                        value-field="id" text-field="name"
                                                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                                                        oninput="setCustomValidity('')" required>
                                                                        <b-form-select-option
                                                                            :value="null"></b-form-select-option>
                                                                    </b-form-select>
                                                                </div>
                                                            </template>
                                                            <template #cell(frequency)="data">
                                                                <div class="text-center">
                                                                    <b-form-input style="text-align: right;"
                                                                        :disabled="item.employee3[data.index].typeFrequency == 'Project'"
                                                                        v-model="item.employee3[data.index].frequency"
                                                                        id="textarea-auto-height" placeholder=""
                                                                        type="number">
                                                                    </b-form-input>
                                                                </div>

                                                            </template>
                                                            <template #cell(notes)="data">
                                                                <div class="text-center">
                                                                    <b-form-input
                                                                        v-model="item.employee3[data.index].notes"></b-form-input>

                                                                </div>

                                                            </template>
                                                        </b-table>

                                                    </b-form-group>

                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>
                                                    <multiselect v-model="addTemplate1" placeholder
                                                        selectedLabel="are selecting" track-by="id" label="content"
                                                        select-label="Enter to select" deselectLabel="Enter to remove"
                                                        :searchable="true" :options="SuggestTemplates2">
                                                    </multiselect>
                                                </b-col>
                                                <b-col>
                                                    <button class="btn btn-info"
                                                        @click.prevent="addTemplate1Func(item.employee3, addTemplate1, 7)">
                                                        <i class="fas fa-plus"></i> Add
                                                    </button>
                                                </b-col>
                                            </b-row>
                                            <b-row style="margin-top: 5px">
                                                <b-col>
                                                    <b-form-group>
                                                        <template v-slot:label>
                                                            <Header value="Director Pitching/ Treatment"></Header>
                                                            <!-- <div
                                                                style="background-color: green; width: 100%; text-align: left;  color: white;">
                                                                <b class="ml-1">Director Pitching/ Treatment</b>
                                                            </div> -->
                                                        </template>
                                                        <b-table head-variant="light" :fields="fieldTemplate" bordered
                                                            hover responsive striped small table-variant="light"
                                                            :items="item.employee4">
                                                            <template v-slot:cell(company)="data">
                                                                <div class="truncate-text">
                                                                    <b-form-select
                                                                        v-model="item.employee4[data.index].company"
                                                                        @input="onChangeCompany(data.index, item.employee4)"
                                                                        class=" pt-0 pb-0" size="md"
                                                                        :options="optionsCompany"
                                                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                                                        oninput="setCustomValidity('')" required>
                                                                    </b-form-select>
                                                                </div>
                                                            </template>
                                                            <template #cell(Content)="data">
                                                                <div class="text-center">
                                                                    {{ data.content }}
                                                                </div>

                                                            </template>

                                                            <template v-slot:cell(name)="data">
                                                                <div class="truncate-text">
                                                                    <b-form-select
                                                                        @input="onInputUser(data.index, item.employee4)"
                                                                        v-model="item.employee4[data.index].user"
                                                                        class=" pt-0 pb-0" size="md"
                                                                        :options="item.employee4[data.index].option"
                                                                        value-field="id" text-field="name"
                                                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                                                        oninput="setCustomValidity('')" required>
                                                                        <b-form-select-option
                                                                            :value="null"></b-form-select-option>
                                                                    </b-form-select>
                                                                </div>
                                                            </template>
                                                            <template #cell(frequency)="data">
                                                                <div class="text-center">
                                                                    <b-form-input style="text-align: right;"
                                                                        :disabled="item.employee4[data.index].typeFrequency == 'Project'"
                                                                        v-model="item.employee4[data.index].frequency"
                                                                        id="textarea-auto-height" placeholder=""
                                                                        type="number">
                                                                    </b-form-input>
                                                                </div>

                                                            </template>
                                                            <template #cell(notes)="data">
                                                                <div class="text-center">
                                                                    <b-form-input
                                                                        v-model="item.employee4[data.index].notes"></b-form-input>

                                                                </div>

                                                            </template>
                                                        </b-table>

                                                    </b-form-group>

                                                </b-col>
                                            </b-row>
                                            <!-- <b-row>
                                                <b-col>
                                                    <multiselect v-model="addTemplate2" placeholder
                                                        selectedLabel="are selecting" track-by="id" label="content"
                                                        select-label="Enter to select" deselectLabel="Enter to remove"
                                                        :searchable="true" :options="SuggestTemplates">
                                                    </multiselect>
                                                </b-col>
                                                <b-col>
                                                    <button class="btn btn-info"
                                                        @click.prevent="addTemplate1Func(item.employee4, addTemplate2, 8)">
                                                        <i class="fas fa-plus"></i> Add
                                                    </button>
                                                </b-col>
                                            </b-row> -->
                                        </template>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="3">
                                    <b-form-group>

                                        <b-form-checkbox id="checkbox-1" v-model="house.outHouse" name="checkbox-1"
                                            :value="true" :unchecked-value="false">
                                            OutHouse
                                        </b-form-checkbox>
                                    </b-form-group>
                                </b-col>

                            </b-row>
                            <b-row>
                                <b-col cols="3">
                                    <b-form-group>

                                        <b-form-checkbox id="checkbox-2" v-model="house.inHouse" name="checkbox-2"
                                            :value="true" :unchecked-value="false">
                                            InHouse
                                        </b-form-checkbox>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="house.inHouse == true">
                                <b-col cols="3">
                                    <b-form-checkbox id="checkbox-3" v-model="house.tvC30" name="checkbox-3"
                                        :value="true" :unchecked-value="false" @input="onChangeHouse">
                                        TVC (6-30s)
                                    </b-form-checkbox>
                                </b-col>
                                <b-col cols="3">
                                    <p>Quantity of version / main film :</p>
                                </b-col>
                                <b-col>
                                    <b-form-input :disabled="!house.tvC30" style="text-align: right;"
                                        v-model="house.tvC30Value" id="textarea-auto-height" placeholder=""
                                        type="number">
                                    </b-form-input>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2" v-if="house.inHouse == true">
                                <b-col cols="3">
                                    <b-form-checkbox id="checkbox-5" v-model="house.tvC60" name="checkbox-5"
                                        :value="true" :unchecked-value="false" @input="onChangeHouse">
                                        TVC (45-60s)
                                    </b-form-checkbox>
                                </b-col>
                                <b-col cols="3">
                                    <p>Quantity of version / main film :</p>
                                </b-col>
                                <b-col>
                                    <b-form-input style="text-align: right;" :disabled="!house.tvC60"
                                        v-model="house.tvC60Value" id="textarea-auto-height" placeholder=""
                                        type="number">
                                    </b-form-input>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2" v-if="house.inHouse == true">
                                <b-col cols="3">
                                    <b-form-checkbox id="checkbox-4" v-model="house.viralClip" name="checkbox-4"
                                        :value="true" :unchecked-value="false" @input="onChangeHouse2">
                                        Viral Clip
                                    </b-form-checkbox>
                                </b-col>
                                <b-col cols="3">
                                    <p>Quantity of version / main film :</p>
                                </b-col>
                                <b-col>
                                    <b-form-input style="text-align: right;" :disabled="!house.viralClip"
                                        v-model="house.viralClipValue" id="textarea-auto-height" placeholder=""
                                        type="number">
                                    </b-form-input>
                                </b-col>
                            </b-row>
                            <!-- <b-row style="margin-top: 5px">
                                <b-col>
                                    <b-form-group>
                                        <template v-slot:label>
                                            Post
                                        </template>
                                        <b-table head-variant="light" :fields="fieldTemplate2" bordered hover responsive
                                            striped small table-variant="light" :items="item.employee5">

                                            <template #cell(Content)="data">
                                                <div class="text-center">
                                                    {{ data.content }}
                                                </div>

                                            </template>


                                            <template #cell(checkBox)="data">
                                                <div class="text-center">
                                                    <b-form-checkbox v-model="item.employee5[data.index].checkBox"
                                                        :value="true" :unchecked-value="false">

                                                    </b-form-checkbox>
                                                </div>

                                            </template>

                                        </b-table>

                                    </b-form-group>

                                </b-col>
                            </b-row> -->
                            <b-row style="margin-top: 5px">
                                <b-col>
                                    <b-form-group>
                                        <template v-slot:label>
                                            <Header value="Post Production"></Header>
                                            <!-- <div
                                                style="background-color: green; width: 100%; text-align: left;  color: white;">
                                                <b class="ml-1">Post Production</b>
                                            </div> -->

                                        </template>
                                        <b-table head-variant="light" :fields="fieldTemplate" bordered hover responsive
                                            striped small table-variant="light" :items="item.employee5">
                                            <!-- <template #cell(checkBox)="data">
                                                                <div class="text-center">
                                                                    <b-form-checkbox
                                                                        v-model="item.employee5[data.index].checkBox"
                                                                        :value="true" :unchecked-value="false"
                                                                        @input="oncheckbox()">

                                                                    </b-form-checkbox>
                                                                </div>

                                                            </template> -->
                                            <template v-slot:cell(company)="data">
                                                <div class="truncate-text">
                                                    <b-form-select v-model="item.employee5[data.index].company"
                                                        @input="onChangeCompany(data.index, item.employee5)"
                                                        class=" pt-0 pb-0" size="md" :options="optionsCompany"
                                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                                        oninput="setCustomValidity('')" required>
                                                    </b-form-select>
                                                </div>
                                            </template>
                                            <template #cell(Content)="data">
                                                <div class="text-center">
                                                    {{ data.content }}
                                                </div>

                                            </template>

                                            <template v-slot:cell(name)="data">
                                                <div class="truncate-text">
                                                    <b-form-select @input="onInputUser(data.index, item.employee5)"
                                                        v-model="item.employee5[data.index].user" class=" pt-0 pb-0"
                                                        size="md" :options="item.employee5[data.index].option"
                                                        value-field="id" text-field="name"
                                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                                        oninput="setCustomValidity('')" required>
                                                        >
                                                        <b-form-select-option :value="null"></b-form-select-option>
                                                    </b-form-select>
                                                </div>
                                            </template>
                                            <template #cell(frequency)="data">
                                                <div class="text-center">
                                                    <b-form-input style="text-align: right;"
                                                        :disabled="item.employee5[data.index].typeFrequency == 'Project'"
                                                        v-model="item.employee5[data.index].frequency"
                                                        id="textarea-auto-height" placeholder="" type="number">
                                                    </b-form-input>
                                                </div>

                                            </template>
                                            <template #cell(notes)="data">
                                                <div class="text-center">
                                                    <b-form-input
                                                        v-model="item.employee5[data.index].notes"></b-form-input>

                                                </div>

                                            </template>
                                        </b-table>

                                    </b-form-group>

                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <multiselect v-model="addTemplate2" placeholder selectedLabel="are selecting"
                                        track-by="id" label="content" select-label="Enter to select"
                                        deselectLabel="Enter to remove" :searchable="true" :options="SuggestTemplates">
                                    </multiselect>
                                </b-col>
                                <b-col>
                                    <button class="btn btn-info"
                                        @click.prevent="addTemplate1Func(item.employee5, addTemplate2, 9)">
                                        <i class="fas fa-plus"></i> Add
                                    </button>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <span style="font-size:16px"> Note </span>
                            </template>
                            <b-row style="min-height: 300px;">
                                <!-- <p style="white-space: pre-line"> {{ note }}</p> -->

                                <pre class="ml-3 mb-0 custom-pre">
                            <p>{{ note }}</p>
                        </pre>

                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-container>
        </b-modal>
        <b-modal v-model="modalLock" @ok="submitLock" header-bg-variant="info" header-text-variant="light">
            <template v-slot:modal-title>

                <div>Lock </div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="info" @click="ok()"><i class="fas fa-save mr-2"></i>Lock</b-button>
                <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Close</b-button>
            </template>
            <b-container>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Lock Time
                                <span class="text-danger">*</span>
                            </template>
                            <vue-datepicker-local style="width: 100%" v-model="item.pm_DatePaid" :local="local"
                                clearable format="MM-YYYY" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Type Lock
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-select v-model="item.typeLock" class="mb-3">

                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- Please select an option
                                        --</b-form-select-option>
                                </template>


                                <b-form-select-option value="in">In</b-form-select-option>
                                <b-form-select-option value="out">Out</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
        <b-modal v-model="modalReportLock" @ok="submitReport2" header-bg-variant="info" header-text-variant="light">
            <template v-slot:modal-title>

                <div>Report</div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="info" @click="ok()"><i class="fas fa-save mr-2"></i>Save</b-button>
                <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Close</b-button>
            </template>
            <b-container>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                From
                                <span class="text-danger">*</span>
                            </template>
                            <vue-datepicker-local style="width: 100%" v-model="report2.from" :local="local" clearable
                                format="MM-YYYY" />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                To
                                <span class="text-danger">*</span>
                            </template>
                            <vue-datepicker-local style="width: 100%" v-model="report2.to" :local="local" clearable
                                format="MM-YYYY" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Company
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-select v-model="report2.company" class=" pt-0 pb-0" size="md"
                                :options="optionsCompany" value-field="madonvi" text-field="madonvi"
                                oninvalid="this.setCustomValidity('Please enter Gender')"
                                oninput="setCustomValidity('')" required>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Employee

                            </template>
                            <!-- <b-form-select  v-model="report.employee" class=" pt-0 pb-0" size="md"
                                :options="SuggestEmployees" value-field="id" text-field="name"
                                oninvalid="this.setCustomValidity('Please enter Gender')"
                                oninput="setCustomValidity('')" required>
                            </b-form-select> -->
                            <multiselect v-model="report2.employee" placeholder selectedLabel="are selecting"
                                track-by="name" label="name" select-label="Enter to select"
                                deselectLabel="Enter to remove" :searchable="true" :options="SuggestEmployees">
                            </multiselect>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal><b-modal v-model="modalReport" @ok="submitReport" header-bg-variant="info"
            header-text-variant="light">
            <template v-slot:modal-title>

                <div>Paid Report </div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="info" @click="ok()"><i class="fas fa-save mr-2"></i>Export</b-button>
                <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Close</b-button>
            </template>
            <b-container>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Paid Month
                                <span class="text-danger">*</span>
                            </template>
                            <vue-datepicker-local style="width: 100%" v-model="report.from" :local="local" clearable
                                format="MM-YYYY" />
                        </b-form-group>
                    </b-col>
                    <!-- <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Month
                                <span class="text-danger">*</span>
                            </template>
                            <vue-datepicker-local style="width: 100%" v-model="report2.to" :local="local" clearable
                                format="MM-YYYY" />
                        </b-form-group>
                    </b-col> -->
                </b-row>
                <!-- <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Company
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-select v-model="report.company" class=" pt-0 pb-0" size="md"
                                :options="optionsCompany" value-field="madonvi" text-field="madonvi"
                                oninvalid="this.setCustomValidity('Please enter Gender')"
                                oninput="setCustomValidity('')" required>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <!-- <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Employee

                            </template>
                       
                            <multiselect v-model="report.employee" placeholder selectedLabel="are selecting"
                                track-by="name" label="name" select-label="Enter to select"
                                deselectLabel="Enter to remove" :searchable="true" :options="SuggestEmployees">
                            </multiselect>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Type Paid
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-select v-model="report.typeLock" class="mb-3">

                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- Please select an option
                                        --</b-form-select-option>
                                </template>


                                <b-form-select-option value="in">In</b-form-select-option>
                                <b-form-select-option value="out">Out</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
        <b-modal v-model="modalPayment" @ok="submitPaid" header-bg-variant="info" header-text-variant="light">
            <template v-slot:modal-title>

                <div>Payment</div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="info" @click="ok()"><i class="fas fa-save mr-2"></i>Save</b-button>
                <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Close</b-button>
            </template>
            <b-container>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Paid out Month
                                <span class="text-danger">*</span>
                            </template>
                            <vue-datepicker-local style="width: 100%" v-model="payment.date" :local="local" clearable
                                format="MM-YYYY" />
                        </b-form-group>
                    </b-col>

                </b-row>
                <!-- <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Company
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-select v-model="payment.company" class=" pt-0 pb-0" size="md"
                                :options="optionsCompany" value-field="madonvi" text-field="madonvi"
                                oninvalid="this.setCustomValidity('Please enter Gender')"
                                oninput="setCustomValidity('')" required>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Action
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-select v-model="payment.action" class="mb-3">

                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- Please select an option
                                        --</b-form-select-option>
                                </template>


                                <b-form-select-option value="pay">Pay</b-form-select-option>
                                <b-form-select-option value="unPay">UnPaid</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";

//import MyCurrencyInput from "../../components/App/MyCurrencyInput.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "vue-swatches/dist/vue-swatches.css";
import VueDatepickerLocal from "vue-datepicker-local";
import HearderModel from "../Bonus/HearderModel.vue";
import Header from "../Bonus/Header.vue";
export default {
    name: "Meetings",
    components: {

        Multiselect,
        // MyCurrencyInput,
        VueDatepickerLocal,
        HearderModel,
        Header
    },
    data() {
        return {
            //fields: [],
            fields: [
                {
                    key: "code",
                    label: "Code",
                    sortable: true,
                    thClass: "align-middle",
                    tdClass: "text-center",
                    thStyle: { textAlign: "center", width: "100px !important", },
                },
                {
                    key: "productionHouse",
                    label: "PH",
                    sortable: true,
                    thClass: "align-middle",
                    thStyle: { width: "75px", textAlign: "center" },
                },
                {
                    key: "projectName",
                    label: "Project name",
                    sortable: true,
                    thClass: "align-middle",
                    thStyle: { textAlign: "center" },
                },

                {
                    key: "ep",
                    label: "EP",
                    sortable: true,
                    thClass: "align-middle",
                    thStyle: { textAlign: "center", width: "170px !important" },
                },
                {
                    key: "pm",
                    label: "PM",
                    sortable: true,
                    thClass: "align-middle",
                    thStyle: { textAlign: "center", width: "170px !important" },
                },
                // {
                //     key: "firstDay",
                //     label: "First day of shooting",
                //     sortable: true,
                // },
                {
                    key: "lastDay",
                    label: "Last day of shooting",
                    sortable: true,
                    thClass: "align-middle",
                    tdClass: "text-center",
                    thStyle: { width: "125px", textAlign: "center" },
                },
                {
                    key: "numberShootingDays",
                    label: "# Days ",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "align-middle",
                    thStyle: { textAlign: "center", width: "75px !important", },
                },
                {
                    key: "pmApprover",
                    label: "Approved by",
                    sortable: true,
                    thClass: "align-middle",
                    thStyle: { textAlign: "center", width: "170px !important" },
                },
                {
                    key: "status",
                    label: "Status",
                    sortable: true,
                    thClass: "align-middle",
                    tdClass: "text-center",
                    thStyle: { textAlign: "center", width: "140px !important" },
                },
                // {
                //     key: "print",
                //     label: "Print",
                //     sortable: true,
                // },
                {
                    key: "pM_DateLock",
                    label: "Paid Date",
                    sortable: true,
                    thClass: "align-middle",
                    tdClass: "text-center",
                    thStyle: { textAlign: "center", width: "125px !important" },
                },
                {
                    key: "action",
                    label: "",
                    tdClass: "text-right",
                    thStyle: { width: "125px !important", textAlign: "right" },
                },
            ],
            fieldWebsite: [
                {
                    key: 'index',
                    label: 'Index',
                    thStyle: { width: "10px", textAlign: "center" },
                },
                {
                    key: "day",
                    label: "Day",
                    tdClass: "text-left",
                    thClass: "align-middle",
                    thStyle: { width: "200px", textAlign: "center" },
                    formatter: this.convertToMMYYYY(),
                },
                {
                    key: "action",
                    label: "Action",
                    tdClass: "text-center",
                    thClass: "align-middle",
                    // thStyle: {width: "80px !important" , textAlign : "center"},
                    thStyle: { width: "20px", textAlign: "center" },
                }
            ],
            fieldTemplate2: [
                {
                    key: 'content',
                    label: 'Position',
                    thStyle: { width: "200px", textAlign: "center" },
                },
                {
                    key: 'checkBox',
                    label: '',
                    thStyle: { width: "250px", textAlign: "center" },
                },

                // {
                //     key: 'action',
                //     label: '',
                // },
            ],
            fieldTemplate: [
                {
                    key: 'company',
                    label: 'Company',
                    thStyle: { width: "50px", textAlign: "center" },
                },
                {
                    key: 'content',
                    label: 'Position',
                    thStyle: { width: "200px", textAlign: "center" },
                },
                {
                    key: 'name',
                    label: 'Name',
                    thStyle: { width: "250px", textAlign: "center" },
                },
                {
                    key: 'frequency',
                    label: 'Point',
                    thStyle: { width: "100px", textAlign: "center" },
                },
                {
                    key: 'notes',
                    label: 'Notes',
                },

            ],
            fieldEmployee: [
                {
                    key: 'username',
                    label: 'Name',
                    thStyle: { width: "100px", },
                },
                {
                    key: 'position',
                    label: 'Position',
                    thStyle: { width: "100px", },
                },
                {
                    key: 'frequency',
                    label: '# Days',
                    thStyle: { width: "50px", textAlign: "center" },
                    tdClass: "text-center",

                },
                // {
                //     key: 'bonus',
                //     label: 'Bonus',
                //     tdClass: "text-right",
                //     // thStyle: { width: "100px", textAlign: "center" },
                // },
                {
                    key: 'notes',
                    label: 'Notes',
                    thStyle: { width: "150px", },
                },

            ],
            local: {
                monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                    "_"
                ), // months of head
                months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split(
                    "_"
                ), // months of panel
                weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks,
                cancelTip: 'X',
                submitTip: 'Ok'
            },
            items: [],
            itemsOriginal: [],
            optionsCompany: [],
            optionEP: [],
            optionPM: [],
            filterMonth: null,
            search: null,

            optionsKyBaoCao_Report3: [
                { value: 0, text: "Jan" },
                { value: 1, text: "Feb" },
                { value: 2, text: "Mar" },
                { value: 3, text: "Apr" },
                { value: 4, text: "May" },
                { value: 5, text: "Jun" },
                { value: 6, text: "Jul" },
                { value: 7, text: "Aug" },
                { value: 8, text: "Sep" },
                { value: 9, text: "Oct" },
                { value: 10, text: "Nov" },
                { value: 11, text: "Dec" },
                { value: 12, text: "Q1" },
                { value: 13, text: "Q2" },
                { value: 14, text: "Q3" },
                { value: 15, text: "Q4" },
                { value: 16, text: "Year" },
            ],
            // item_null: {
            //     id: 0,
            //     code: "",
            //     productionHouse: "",
            //     projectName: "",
            //     client: "",
            //     EP: null,
            //     dateLiquidation: "",
            //     EPRevenue: 0,
            //     EPGross: 0,
            //     EPBonus: 0,
            //     EPPaid: 0,
            //     EPKPI: 0,
            //     EPStatus: 0,
            //     EPLock: false,
            //     PM: null,
            //     PMApprover: 0,
            //     daysOfShooting: [],
            //     employee1: [],
            //     employee2: [],
            //     employee3: []
            // },
            item: {
                id: 0,
                code: "",
                productionHouse: "",
                projectName: "",
                client: "",
                EP: null,
                dateLiquidation: "",
                // EPRevenue: 0,
                // EPGross: 0,
                // EPBonus: 0,
                // EPPaid: 0,
                // EPKPI: 0,
                // EPStatus: 0,
                pmLock: false,
                pmLockPaid: false,
                // EPLock: false,
                PM: null,
                PMApprover: [],
                daysOfShooting: [],
                employee1: [],
                employee2: [],
                employee3: [],
                employee4: [],
                employee5: [],
                employees: [],
                dayOfMasterDelivery: "",
                pm_DatePaid: "",
                typeLock: null,
                status: "",
            },
            house: {
                id: 0,
                inHouse: false,
                outHouse: false,
                projectID: 0,
                tvC30: false,
                tvC30Value: 0,
                tvC60: false,
                tvC60Value: 0,
                type: "POST-SHOOTING",
                viralClip: false,
                viralClipValue: 0,
            },
            typePage: null,
            modalShow: false,
            totalRows: 1,
            currentPage: 1,
            perPage: 50,
            SuggestEmployees: [],
            SuggestEmployeesALL: [],
            tmpDay: null,
            tabIndex: 0,
            postApprove: [],
            postApprove2: [],
            SuggestTemplates: [],
            SuggestTemplates2: [],
            addTemplate1: null,
            addTemplate2: null,
            itemIdex: 0,
            modalLock: false,
            modalPayment: false,
            payment: {
                date: null,
                company: "All",
                action: "pay"
            },
            report: {
                to: null,
                from: null,
                company: "All",
                employee: 0,
                typeLock: "in"
            },
            report2: {
                to: null,
                from: null,
                company: "All",
                employee: 0,

            },
            modalReport: false,
            modalReportLock: false,
            Reporting: false,
            Reporting2: false,
            searchBonus: {
                status: null,
                productionHouse: 'All',
                approveBy: null,
                optionApprove: [],
                filterDate: null,
                from: null,
                to: null,
            },
            note: "",
        };
    },
    computed: {
        black_key() {
            return this.$store.getters.hasPermission("black_key");
        },
        bonus_ps_view() {
            return this.$store.getters.hasPermission("bonus_ps_view");
        },
        bonus_ps_view_all() {
            return this.$store.getters.hasPermission("bonus_ps_view_all");
        },
        bonus_ps_edit() {
            return this.$store.getters.hasPermission("bonus_ps_edit");
        },
        bonus_ps_edit_approve() {
            return this.$store.getters.hasPermission("bonus_ps_edit_approve");
        },
        bonus_ps_edit_pm() {
            return this.$store.getters.hasPermission("bonus_ps_edit_pm");
        },
        bonus_ps_delete() {
            return this.$store.getters.hasPermission("bonus_ps_delete");
        },
        bonus_ps_report() {
            return this.$store.getters.hasPermission("bonus_ps_report");
        },
        bonus_ps_approve() {
            return this.$store.getters.hasPermission("bonus_ps_approve");
        },
        bonus_ps_submit_approve() {
            return this.$store.getters.hasPermission("bonus_ps_submit_approve");
        },
        bonus_ps_lock() {
            return this.$store.getters.hasPermission("bonus_ps_lock");
        },
        bonus_ps_payment() {
            return this.$store.getters.hasPermission("bonus_ps_payment");
        },
        bonus_ps_submit_approve_edit() {
            return this.$store.getters.hasPermission("bonus_ps_submit_approve_edit");
        },
    },
    beforeRouteEnter(to, from, next) {
        //this.typePage = to.params.type;
        axios
            .all([
                axios.get(`/api/PostSales/getAll`),
                axios.get("/api/SalesBonus/GetDepartmentAll"),
                axios.get("/api/PostSales/SuggestEmployee"),
                axios.get("/api/role/2064/employee"),
                axios.get("/api/PostSales/GetSuggestTemplate"),
                axios.get("/api/PostSales/GetSuggestTemplate2"),
                axios.get("/api/bonus/getNoteBonus"),
                axios.get("/api/SalesBonus/getPMSuggest"),
                //axios.get("/api/picklist?q=vitricongviec"),
            ])
            .then(
                axios.spread((bonusRate, department, employees, postApprove, suggestTemplates, suggestTemplates2, note, newPM) => {
                    next((vm) =>
                        vm.initData(bonusRate.data, department.data, employees.data, postApprove.data, suggestTemplates.data, suggestTemplates2.data, note.data, newPM.data)
                    );
                })
            );
    },
    beforeRouteUpdate(to, from, next) {
        axios
            .get("/api/PostSales/getAll", { params: to.query })
            .then((response) => {
                this.items = response.data;
                this.onFiltered(response.data);
            })
            .catch((err) => {
                next();
            });
    },
    watch: {},
    methods: {
        initData(bonusRate, department, employees, postApprove, suggestTemplates, suggestTemplates2, note, newPM) {
            this.postApprove = postApprove.items;
            this.SuggestEmployees = employees;
            this.optionPM = newPM;
            //this.SuggestEmployeesALL = employees;
            this.items = bonusRate;
            department.push("All");
            this.optionsCompany = department;
            this.onFiltered(bonusRate);
            this.SuggestTemplates = suggestTemplates;
            this.SuggestTemplates2 = suggestTemplates2;
            this.postApprove.forEach(element => {
                var emp = employees.filter(x => x.id == element.id);
                // this.$log(emp);
                var item = { value: element.id, text: emp[0].name };
                this.searchBonus.optionApprove.push(item);
            });
            this.note = note;
        },
        changeDateFilter() {
            const monthDays = {
                0: [0, 1, 0, 31],
                1: [1, 1, 2, 0],
                2: [2, 1, 2, 31],
                3: [3, 1, 3, 30],
                4: [4, 1, 4, 31],
                5: [5, 1, 5, 30],
                6: [6, 1, 6, 31],
                7: [7, 1, 7, 31],
                8: [8, 1, 8, 30],
                9: [9, 1, 9, 31],
                10: [10, 1, 10, 30],
                11: [11, 1, 11, 31],
                12: [0, 1, 2, 31],
                13: [3, 1, 5, 30],
                14: [6, 1, 8, 30],
                15: [9, 1, 11, 31],
                16: [0, 1, 11, 31]
            };
            if (this.searchBonus.filterDate != null) {
                const [fromMonth, fromDay, toMonth, toDay] = monthDays[this.searchBonus.filterDate];
                this.searchBonus.from = new Date(new Date().getFullYear(), fromMonth, fromDay);
                this.searchBonus.to = new Date(new Date().getFullYear(), toMonth, toDay);
            } else {
                this.searchBonus.from = null;
                this.searchBonus.to = null;
            }
            this.queryItem();
        },
        checkID(id){
            return this.$store.state.auth.accountId == id;
        },
        convertToMMYYYY2(dateString) {

            if (dateString == null) return dateString;
            dateString = this.$convert_date_string(dateString);
            // Split the input string into day, month, and year components
            const [day, month, year] = dateString.split('/');

            // Create a new Date object using the components
            const dateObject = new Date(`${month}/01/${year}`);

            // Get month and year components from the Date object
            const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const convertedYear = dateObject.getFullYear();

            // Return the formatted string
            return `${convertedMonth}-${convertedYear}`;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        // openModal() {

        //     this.item = JSON.parse(JSON.stringify(this.item_null));
        //     this.modalShow = true;
        //     this.optionPM = [];
        //     this.optionEP = [];
        // },
        addNewDay() {
            if (this.tmpDay == null) {
                this.$toast.error("The date format is valid", "Error", {
                    timeout: 3000,
                });
                return;
            }
            //this.tmpDay = this.$formatDateToDDMMYYYY(new Date(this.tmpDay));

            var item = {
                day: this.tmpDay,
            }
            this.item.daysOfShooting.push(item);
            //this.item.daysOfShooting.sort();
            this.item.daysOfShooting.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(a.day) - new Date(b.day);
            });
            this.tmpDay = null;
        },
        convertToMMYYYY(day) {
            return this.$formatDateToDDMMYYYY(new Date(day));
        },
        deleteDay(data) {
            this.item.daysOfShooting.splice(data.index, 1);
        },
        convertName(id) {
            var rs = "";
            this.SuggestEmployees.forEach(element => {
                //this.$log(element.id + " - " + id);
                if (element.id == id) {
                    //this.$log(element.name);
                    rs = element.name;
                }
            });
            return rs;
        },
        convertPosition(id) {
            var rs = "";
            this.SuggestEmployees.forEach(element => {
                //this.$log(element.id + " - " + id);
                if (element.id == id) {
                    //this.$log(element.name);
                    rs = element.position;
                }
            });
            return rs;
        },
        onChangeHouse() {
            if (this.house.tvC30 == true || this.house.tvC60 == true) {
                this.house.viralClip = false;
                this.house.viralClipValue = 0;
            }

        },
        onChangeHouse2() {
            if (this.house.viralClip == true) {
                this.house.tvC30 = false;
                this.house.tvC60 = false;
                this.house.tvC30Value = 0;
                this.house.tvC60Value = 0;
            }
        },
        openUpdateModal(data) {

            // this.item = JSON.parse(JSON.stringify(data.item));
            // this.$log(this.item);
            this.tabIndex = 1;
            this.item.id = data.item.id;
            this.item.code = data.item.code;
            this.item.productionHouse = data.item.productionHouse;
            this.item.client = data.item.client;
            this.item.projectName = data.item.projectName;

            this.item.EP = this.SuggestEmployees.find(e => e.id == data.item.ep);
            this.item.PM = this.SuggestEmployees.find(e => e.id == data.item.pm);
            this.$log("dcm" + data.item.pmApprover);
            if (data.item.pmApprover != null) {

                this.item.PMApprover = this.postApprove.find(e => e.id == data.item.pmApprover);
            }
            var tmpApprove = [];
            // this.postApprove.forEach(element => {
            //     var chek = this.SuggestEmployees.find(e => e.id == element.id && e.company == data.item.productionHouse);
            //     if (chek != null) {
            //         tmpApprove.push(element);
            //     }
            // });
            this.postApprove2 = this.postApprove;
            this.item.dayOfMasterDelivery = JSON.parse(JSON.stringify(data.item.dayOfMasterDelivery));
            this.item.daysOfShooting = JSON.parse(JSON.stringify(data.item.days));
            this.item.status = data.item.status;
            axios
                .get(`/api/PostSales/GetTemplate?projectId=${data.item.id}`)
                .then((res) => {
                    if (data.item.productionHouse == "GS") {
                        this.item.employee1 = res.data.items.filter(e => e.groupID == 10);
                        this.item.employee1.forEach((element, index) => {
                            // if (element.frequency == 0 && element.typeFrequency == 'Day') {
                            //     element.frequency = null;
                            // }
                            element.company = data.item.productionHouse;
                            element.option = this.SuggestEmployees.filter(e => (e.id == element.user || e.position == element.role || ((element.role2 != null || element.role2 != "") && e.position == element.role2)) && e.company == data.item.productionHouse);
                        });
                    } else {
                        this.item.employee1 = res.data.items.filter(e => e.groupID == 4);
                        this.item.employee1.forEach((element, index) => {
                            // if (element.frequency == 0 && element.typeFrequency == 'Day') {
                            //     element.frequency = null;
                            // }
                            element.company = data.item.productionHouse;
                            element.option = this.SuggestEmployees.filter(e => (e.id == element.user || e.position == element.role || ((element.role2 != null || element.role2 != "") && e.position == element.role2)) && e.company == data.item.productionHouse);
                        });
                    }

                    this.item.employee2 = res.data.items.filter(e => e.groupID == 5);
                    this.item.employee2.forEach(element => {
                        // if (element.frequency == 0 && element.typeFrequency == 'Day') {
                        //         element.frequency = null;
                        //     }
                        if (element.company.length > 0)
                            if (element.company == "All") {
                                element.option = this.SuggestEmployees.filter(e => (e.position == element.role || (element.role2 != null && e.position == element.role2)));
                            } else {
                                element.option = this.SuggestEmployees.filter(e => (e.id == element.user || e.position == element.role || (element.role2 != null && e.position == element.role2)) && e.company == element.company);
                            }

                        else {
                            element.company = "All";
                            element.option = this.SuggestEmployees.filter(e => (e.position == element.role || (element.role2 != null && e.position == element.role2)));
                        }
                    });
                    this.item.employee3 = res.data.items.filter(e => e.groupID == 7);
                    this.item.employee3.forEach(element => {
                        // if (element.frequency == 0 && element.typeFrequency == 'Day') {
                        //         element.frequency = null;
                        //     }
                        if (element.company.length > 0)
                            if (element.company == "All") {
                                element.option = this.SuggestEmployees.filter(e => (e.position == element.role || (element.role2 != null && e.position == element.role2)));
                            } else {
                                element.option = this.SuggestEmployees.filter(e => (e.id == element.user || e.position == element.role || (element.role2 != null && e.position == element.role2)) && e.company == element.company);
                            }

                        else {
                            element.company = "All";
                            element.option = this.SuggestEmployees.filter(e => (e.position == element.role || (element.role2 != null && e.position == element.role2)));
                        }
                    });
                    this.item.employee4 = res.data.items.filter(e => e.groupID == 8);
                    this.item.employee4.forEach(element => {
                        // if (element.frequency == 0 && element.typeFrequency == 'Day') {
                        //         element.frequency = null;
                        //     }
                        if (element.company.length > 0)
                            if (element.company == "All") {
                                element.option = this.SuggestEmployees.filter(e => (e.position == element.role || (element.role2 != null && e.position == element.role2)));
                            } else {
                                element.option = this.SuggestEmployees.filter(e => (e.id == element.user || e.position == element.role || (element.role2 != null && e.position == element.role2)) && e.company == element.company);
                            }

                        else {
                            element.company = "All";
                            element.option = this.SuggestEmployees.filter(e => (e.position == element.role || (element.role2 != null && e.position == element.role2)));
                        }
                    });
                    // this.item.employee5 = res.data.items.filter(e => e.groupID == 9);
                    this.item.employee5 = res.data.items.filter(e => e.groupID == 9);
                    this.item.employee5.forEach(element => {
                        // if (element.frequency == 0 && element.typeFrequency == 'Day') {
                        //         element.frequency = null;
                        //     }
                        if (element.company.length > 0)
                            if (element.company == "All") {
                                element.option = this.SuggestEmployees.filter(e => (e.position == element.role || (element.role2 != null && e.position == element.role2)));
                            } else {
                                element.option = this.SuggestEmployees.filter(e => (e.id == element.user || e.position == element.role || (element.role2 != null && e.position == element.role2)) && e.company == element.company);
                            }

                        else {
                            element.company = "All";
                            element.option = this.SuggestEmployees.filter(e => (e.position == element.role || (element.role2 != null && e.position == element.role2)));
                        }
                    });

                    this.house.id = res.data.house.id;
                    this.house.inHouse = res.data.house.inHouse;
                    this.house.outHouse = res.data.house.outHouse;
                    this.house.projectID = res.data.house.projectID;
                    this.house.tvC30 = res.data.house.tvC30;
                    this.house.tvC30Value = res.data.house.tvC30Value;
                    this.house.tvC60 = res.data.house.tvC60;
                    this.house.tvC60Value = res.data.house.tvC60Value;
                    this.house.type = res.data.house.type;
                    this.house.viralClip = res.data.house.viralClip;
                    this.house.viralClipValue = res.data.house.viralClipValue;
                    this.$log(this.house);
                })
                .catch((err) => {
                    this.$log(err);
                });

            this.itemIdex = this.items.indexOf(data.item);
            this.modalShow = true;
        },
        exportReport2() {

            this.modalReportLock = true;
        },
        openModalPayment() {

            this.modalPayment = true;
        },
        exportReport() {

            this.modalReport = true;
        },
        changeDate() {
            if (this.searchBonus.from != null && this.searchBonus.to != null) {
                this.queryItem();
            }
        },
        submitPaid() {
            const formSubmit = {
                time: this.payment.date,
                company: this.payment.company,
                action: this.payment.action
            };
            axios
                .post(`/api/PostSales/ChangePaidStatus`, formSubmit)
                .then((res) => {

                    this.$toast.success("Update successfully !", "Successful", {
                        timeout: 3000,
                    });

                    this.modalPayment = false;

                    this.queryItem();


                })
                .catch((err) => {
                    //this.$log(err);
                    this.$toast.error(err.response.data, "Error", { timeout: 3000 });
                });
        },
        submitReport2() {
            this.Reporting2 = true;
            var id = 0;
            if (this.report2.employee.length > 0) {
                id = this.report2.employee.id;
            }


            const model = {

                to: this.report2.to,
                from: this.report2.from,
                company: this.report2.company,
                id: this.report2.employee.id,
                //typeLock: "in"
            };
            // axios.get(`/api/PostSales/Report2`, {
            //     responseType: 'blob', params: model
            // })
            //     .then((res) => {
            //         let filename = res.headers["content-disposition"]
            //             .split(";")
            //             .find(function (el) {
            //                 if (el.includes("filename=")) return el;
            //             })
            //             .replace("filename=", "")
            //             .trim();
            //         const url = window.URL.createObjectURL(
            //             new Blob([res.data], {
            //                 type: "application/vnd.ms-excel;charset=utf-8",
            //             })
            //         );
            //         const link = document.createElement("a");
            //         link.href = url;
            //         link.setAttribute("download", filename); //or any other extension
            //         document.body.appendChild(link);
            //         link.click();
            //         this.Reporting2 = false;
            //     }).catch((err) => {
            //         //this.$log(err);
            //         this.$toast.error(err.response.data, "Error", { timeout: 3000 });
            //     });
            axios.get(`/api/PostSales/Report2`, {
                responseType: 'blob',
                params: model
            })
                .then((res) => {
                    let filename = res.headers["content-disposition"]
                        .split(";")
                        .find(function (el) {
                            if (el.includes("filename=")) return el;
                        })
                        .replace("filename=", "")
                        .trim();
                    const url = window.URL.createObjectURL(
                        new Blob([res.data], {
                            type: "application/vnd.ms-excel;charset=utf-8",
                        })
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", filename); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.Reporting2 = false;
                })
                .catch((err) => {
                    this.Reporting2 = false;
                    const blob = err.response.data;
                    const reader = new FileReader();
                    reader.onload = () => {
                        let errorText = reader.result;

                        // Ensure the message is a string
                        if (typeof errorText !== 'string') {
                            errorText = JSON.stringify(errorText);
                        }

                        // Assuming errorText is JSON formatted
                        try {
                            const errorJson = JSON.parse(errorText);
                            this.$toast.error(errorJson.message || errorText, "Error", { timeout: 3000 });

                        } catch (e) {
                            this.$toast.error(errorText, "Error", { timeout: 3000 });
                        }
                    };
                    reader.onerror = () => {
                        this.$toast.error("An error occurred while processing the error response.", "Error", { timeout: 3000 });
                    };
                    reader.readAsText(blob);

                });

        },
        PrintDetail() {

            const model = {
                projectID: this.item.id,
                type: "Shooting",
            };
            axios.get(`/api/SalesBonus/PrintDetail`, {
                responseType: 'blob',
                params: model
            })
                .then((res) => {
                    let filename = res.headers["content-disposition"]
                        .split(";")
                        .find(function (el) {
                            if (el.includes("filename=")) return el;
                        })
                        .replace("filename=", "")
                        .trim();
                    const url = window.URL.createObjectURL(
                        new Blob([res.data], {
                            type: "application/vnd.ms-excel;charset=utf-8",
                        })
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", filename); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.Reporting = false;
                })
                .catch((err) => {
                    this.Reporting = false;
                    const blob = err.response.data;
                    const reader = new FileReader();
                    reader.onload = () => {
                        let errorText = reader.result;

                        // Ensure the message is a string
                        if (typeof errorText !== 'string') {
                            errorText = JSON.stringify(errorText);
                        }

                        // Assuming errorText is JSON formatted
                        try {
                            const errorJson = JSON.parse(errorText);
                            this.$toast.error(errorJson.message || errorText, "Error", { timeout: 3000 });

                        } catch (e) {
                            this.$toast.error(errorText, "Error", { timeout: 3000 });
                        }
                    };
                    reader.onerror = () => {
                        this.$toast.error("An error occurred while processing the error response.", "Error", { timeout: 3000 });
                    };
                    reader.readAsText(blob);

                });
        },
        submitReport() {
            this.Reporting = true;
            var id = 0;
            if (this.report.employee.length > 0) {
                id = this.report.employee.id;
            }

            this.$log(this.report.employee);
            const model = {
                to: this.report.from,
                //to: this.report.to,
                from: this.report.from,
                company: this.report.company,
                id: this.report.employee.id,
                typeLock: this.report.typeLock
            };
            axios.get(`/api/PostSales/Report1`, {
                responseType: 'blob',
                params: model
            })
                .then((res) => {
                    let filename = res.headers["content-disposition"]
                        .split(";")
                        .find(function (el) {
                            if (el.includes("filename=")) return el;
                        })
                        .replace("filename=", "")
                        .trim();
                    const url = window.URL.createObjectURL(
                        new Blob([res.data], {
                            type: "application/vnd.ms-excel;charset=utf-8",
                        })
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", filename); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.Reporting = false;
                })
                .catch((err) => {
                    this.Reporting = false;
                    const blob = err.response.data;
                    const reader = new FileReader();
                    reader.onload = () => {
                        let errorText = reader.result;

                        // Ensure the message is a string
                        if (typeof errorText !== 'string') {
                            errorText = JSON.stringify(errorText);
                        }

                        // Assuming errorText is JSON formatted
                        try {
                            const errorJson = JSON.parse(errorText);
                            this.$toast.error(errorJson.message || errorText, "Error", { timeout: 3000 });

                        } catch (e) {
                            this.$toast.error(errorText, "Error", { timeout: 3000 });
                        }
                    };
                    reader.onerror = () => {
                        this.$toast.error("An error occurred while processing the error response.", "Error", { timeout: 3000 });
                    };
                    reader.readAsText(blob);

                });
        },
        convertDate(array) {
            return this.$convert_date_string(array);
            // if (array.length > 0) {
            //     return this.$convert_date_string(array[array.length - 1].day);
            // }
            // else return "";
        },
        convertDate2(array) {
            if (array.length > 0) {
                return this.$convert_date_string(array[0].day);
            }
            else return "";
        },
        addTemplate1Func(list, template, groupID) {
            if (template != null) {
                template.groupID = groupID;
                var tmp = JSON.parse(JSON.stringify(template));
                tmp.company = 'All';
                list.push(tmp);
                this.onChangeCompany(list.length - 1, list);
                //list.sort();
            }

            template = null;
        },
        unlockHopitalCity(city) {
            this.item.EP = null;
        },
        lockHopitalCity() {
            this.item.EP = null;
        },
        storeItem2(bvModalEvt) {

            // this.item.updateBy = this.$store.state.auth.accountId;
            // this.item.type = this.typePage;
            this.$log(this.item.PMApprover);
            if (this.item.PMApprover == null || this.item.PMApprover.length == 0) {
                this.$toast.error("Approver  is empty !", "ERROR", {
                    timeout: 3000,
                });
                return;
            }
            if (this.item.dayOfMasterDelivery == null || this.item.dayOfMasterDelivery == '') {
                this.$toast.error("Day of Master Delivery  is empty !", "ERROR", {
                    timeout: 3000,
                });
                return;
            }
            if (this.item.daysOfShooting == null || this.item.daysOfShooting.length  == 0) {
                this.$toast.error("Day of Shooting  is empty !", "ERROR", {
                    timeout: 3000,
                });
                return;
            }
            var employee = [];
            this.item.employee1.forEach(element => {
                var tmp = {
                    checkBox: element.checkBox,
                    company: element.company,
                    content: element.content,
                    frequency: Number(element.frequency),
                    groupID: element.groupID,
                    id: element.id,
                    notes: element.notes,

                    role: element.role,
                    role2: element.role2,
                    user: element.user == null ? 0 : Number(element.user)
                };
                employee.push(tmp);
            });
            this.item.employee2.forEach(element => {
                var tmp = {
                    checkBox: element.checkBox,
                    company: element.company,
                    content: element.content,
                    frequency: Number(element.frequency),
                    groupID: element.groupID,
                    id: element.id,
                    notes: element.notes,

                    role: element.role,
                    role2: element.role2,
                    user: element.user == null ? 0 : Number(element.user)
                };
                employee.push(tmp);
            });
            this.item.employee3.forEach(element => {
                var tmp = {
                    checkBox: element.checkBox,
                    company: element.company,
                    content: element.content,
                    frequency: Number(element.frequency),
                    groupID: element.groupID,
                    id: element.id,
                    notes: element.notes,

                    role: element.role,
                    role2: element.role2,
                    user: element.user == null ? 0 : Number(element.user)
                };
                employee.push(tmp);
            });
            this.item.employee4.forEach(element => {
                var tmp = {
                    checkBox: element.checkBox,
                    company: element.company,
                    content: element.content,
                    frequency: Number(element.frequency),
                    groupID: element.groupID,
                    id: element.id,
                    notes: element.notes,

                    role: element.role,
                    role2: element.role2,
                    user: element.user == null ? 0 : Number(element.user)
                };
                employee.push(tmp);
            });
            this.item.employee5.forEach(element => {
                var tmp = {
                    checkBox: element.checkBox,
                    company: element.company,
                    content: element.content,
                    frequency: Number(element.frequency),
                    groupID: element.groupID,
                    id: element.id,
                    notes: element.notes,

                    role: element.role,
                    role2: element.role2,
                    user: element.user == null ? 0 : Number(element.user)
                };
                employee.push(tmp);
            });
            this.house.tvC30Value = Number(this.house.tvC30Value);
            this.house.tvC60Value = Number(this.house.tvC60Value);
            this.house.viralClipValue = Number(this.house.viralClipValue);
            const formSubmit = {
                projectID: this.item.id,
                daysOfShooting: this.item.daysOfShooting.map(x => x.day),
                PMApprover: this.item.PMApprover.id,
                employee: employee,
                dayOfMasterDelivery: this.item.dayOfMasterDelivery,
                house: this.house,
                updateBy: this.$store.state.auth.accountId
            };
            axios
                .post(`/api/PostSales/StorePostShotingBlack`, formSubmit)
                .then((res) => {
                    // if (this.item.id <= 0) {
                    //     this.items.push(res.data[0]);
                    //     this.$toast.success("Create successfully !", "Successful", {
                    //         timeout: 3000,
                    //     });
                    // } else {
                    //     this.items.splice(this.itemIdex, 1, res.data[0]);
                    this.$toast.success("Update successfully !", "Successful", {
                        timeout: 3000,
                    });
                    // }
                    this.items.splice(this.itemIdex, 1, res.data[0]);
                    this.modalShow = false;



                })
                .catch((err) => {
                    //this.$log(err);
                    this.$toast.error(err.response.data, "Error", { timeout: 3000 });
                });
        },
        storeItem(bvModalEvt) {

            // this.item.updateBy = this.$store.state.auth.accountId;
            // this.item.type = this.typePage;
            this.$log(this.item.PMApprover);
            if (this.item.PMApprover == null || this.item.PMApprover.length == 0) {
                this.$toast.error("Approver  is empty !", "ERROR", {
                    timeout: 3000,
                });
                return;
            }
            if (this.item.dayOfMasterDelivery == null || this.item.dayOfMasterDelivery == '') {
                this.$toast.error("Day of Master Delivery  is empty !", "ERROR", {
                    timeout: 3000,
                });
                return;
            }
            if (this.item.daysOfShooting == null || this.item.daysOfShooting.length  == 0) {
                this.$toast.error("Day of Shooting  is empty !", "ERROR", {
                    timeout: 3000,
                });
                return;
            }
            var employee = [];
            this.item.employee1.forEach(element => {
                var tmp = {
                    checkBox: element.checkBox,
                    company: element.company,
                    content: element.content,
                    frequency: Number(element.frequency),
                    groupID: element.groupID,
                    id: element.id,
                    notes: element.notes,

                    role: element.role,
                    role2: element.role2,
                    user: element.user == null ? 0 : Number(element.user)
                };
                employee.push(tmp);
            });
            this.item.employee2.forEach(element => {
                var tmp = {
                    checkBox: element.checkBox,
                    company: element.company,
                    content: element.content,
                    frequency: Number(element.frequency),
                    groupID: element.groupID,
                    id: element.id,
                    notes: element.notes,

                    role: element.role,
                    role2: element.role2,
                    user: element.user == null ? 0 : Number(element.user)
                };
                employee.push(tmp);
            });
            this.item.employee3.forEach(element => {
                var tmp = {
                    checkBox: element.checkBox,
                    company: element.company,
                    content: element.content,
                    frequency: Number(element.frequency),
                    groupID: element.groupID,
                    id: element.id,
                    notes: element.notes,

                    role: element.role,
                    role2: element.role2,
                    user: element.user == null ? 0 : Number(element.user)
                };
                employee.push(tmp);
            });
            this.item.employee4.forEach(element => {
                var tmp = {
                    checkBox: element.checkBox,
                    company: element.company,
                    content: element.content,
                    frequency: Number(element.frequency),
                    groupID: element.groupID,
                    id: element.id,
                    notes: element.notes,

                    role: element.role,
                    role2: element.role2,
                    user: element.user == null ? 0 : Number(element.user)
                };
                employee.push(tmp);
            });
            this.item.employee5.forEach(element => {
                var tmp = {
                    checkBox: element.checkBox,
                    company: element.company,
                    content: element.content,
                    frequency: Number(element.frequency),
                    groupID: element.groupID,
                    id: element.id,
                    notes: element.notes,

                    role: element.role,
                    role2: element.role2,
                    user: element.user == null ? 0 : Number(element.user)
                };
                employee.push(tmp);
            });
            this.house.tvC30Value = Number(this.house.tvC30Value);
            this.house.tvC60Value = Number(this.house.tvC60Value);
            this.house.viralClipValue = Number(this.house.viralClipValue);
            const formSubmit = {
                projectID: this.item.id,
                daysOfShooting: this.item.daysOfShooting.map(x => x.day),
                PMApprover: this.item.PMApprover.id,
                employee: employee,
                dayOfMasterDelivery: this.item.dayOfMasterDelivery,
                house: this.house,
                updateBy: this.$store.state.auth.accountId
            };
            axios
                .post(`/api/PostSales/StorePostShoting`, formSubmit)
                .then((res) => {
                    // if (this.item.id <= 0) {
                    //     this.items.push(res.data[0]);
                    //     this.$toast.success("Create successfully !", "Successful", {
                    //         timeout: 3000,
                    //     });
                    // } else {
                    //     this.items.splice(this.itemIdex, 1, res.data[0]);
                    this.$toast.success("Update successfully !", "Successful", {
                        timeout: 3000,
                    });
                    // }
                    this.items.splice(this.itemIdex, 1, res.data[0]);
                    this.modalShow = false;



                })
                .catch((err) => {
                    //this.$log(err);
                    this.$toast.error(err.response.data, "Error", { timeout: 3000 });
                });
        },
        submitLock() {
            if (this.item.pm_DatePaid == null || this.item.pm_DatePaid == '') {
                this.$toast.error("Date is empty !", "ERROR", {
                    timeout: 3000,
                });
                return;
            } else if (this.item.typeLock == null) {
                this.$toast.error("Please select Type of Lock !", "ERROR", {
                    timeout: 3000,
                });
                return;
            }
            else {
                const formSubmit = {
                    projectID: this.item.id,
                    dateTime: this.item.pm_DatePaid,
                    typeLock: this.item.typeLock
                };
                axios
                    .post(`/api/PostSales/LockProject`, formSubmit)
                    .then((res) => {
                        this.items.splice(this.itemIdex, 1, res.data[0]);
                        this.$toast.success("Lock successfully !", "Successful", {
                            timeout: 3000,
                        });
                    })
                    .catch((err) => {
                        this.$toast.error(err.response.data, "ERROR", {
                            timeout: 3000,
                        });
                    });
            }
        },
        SendApprove(item) {
            this.$toast.question("Please confirm if you want to proceed with sending the email?", "Warning", {
                timeout: 20000,
                close: false,
                overlay: true,
                displayMode: "once",
                position: "center",
                buttons: [

                    [
                        "<button><b>Sent</b></button>",
                        (instance, toast) => {
                            axios
                                .get(`/api/PostSales/SentMail?projectID=${item.id}&updatedBy=${this.$store.state.auth.accountId}&sent=${true}`)
                                .then((res) => {
                                    //this.items.splice(this.itemIdex, 1, res.data[0]);
                                    item.status = 'PM-Pending Approval';
                                    this.$toast.success("Sent Mail successfully !", "Successful", {
                                        timeout: 3000,
                                    });
                                })
                                .catch((err) => {
                                    this.$toast.error(err.response.data, "ERROR", {
                                        timeout: 3000,
                                    });
                                });
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                        true,
                    ],
                    // [
                    //     "<button><b>Don't send</b></button>",
                    //     (instance, toast) => {
                    //         axios
                    //         .get(`/api/PostSales/SentMail?projectID=${item.id}&updatedBy=${this.$store.state.auth.accountId}`)
                    //         .then((res) => {
                    //             //this.items.splice(this.itemIdex, 1, res.data[0]);
                    //             item.status = 'PM-Pending Approval';
                    //             this.$toast.success("Sent Mail successfully !", "Successful", {
                    //                 timeout: 3000,
                    //             });
                    //         })
                    //         .catch((err) => {
                    //             this.$toast.error(err.response.data, "ERROR", {
                    //                 timeout: 3000,
                    //             });
                    //         });
                    //         instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                    //     },
                    //     true,
                    // ],
                    [
                        "<button>Cancel</button>",
                        function (instance, toast) {
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                    ],
                ],
            });



        },

        approveRequest(data) {
            if (data.item.status == 'PM-Approved') {
                this.$toast.question("Do you agree to reject this project?", "Warning", {
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    displayMode: "once",
                    position: "center",
                    buttons: [

                        [
                            "<button><b>Reject</b></button>",
                            (instance, toast) => {
                                axios
                                    .get(`/api/PostSales/UnApproveRequest?projectID=${data.item.id}`)
                                    .then((res) => {
                                        this.items.splice(data.index, 1, res.data[0]);
                                        this.$toast.success("Reject successfully !", "Successful", {
                                            timeout: 3000,
                                        });
                                    })
                                    .catch((err) => {
                                        this.$toast.error(err.response.data, "ERROR", {
                                            timeout: 3000,
                                        });
                                    });
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                            true,
                        ],
                        [
                            "<button>Cancel</button>",
                            function (instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                        ],
                    ],
                });
            } else {
                this.$toast.question("Do you agree to approve this project?", "Warning", {
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    displayMode: "once",
                    position: "center",
                    buttons: [
                        [
                            `<button v-if="${1 == 0}"><b>Approve</b></button>`,
                            (instance, toast) => {
                                axios
                                    .get(`/api/PostSales/ApproveRequest?projectID=${data.item.id}`)
                                    .then((res) => {
                                        this.items.splice(data.index, 1, res.data[0]);
                                        this.$toast.success("Approve successfully !", "Successful", {
                                            timeout: 3000,
                                        });
                                    })
                                    .catch((err) => {
                                        this.$toast.error(err.response.data, "ERROR", {
                                            timeout: 3000,
                                        });
                                    });
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                            true,
                        ],
                        [
                            "<button><b>Reject</b></button>",
                            (instance, toast) => {
                                axios
                                    .get(`/api/PostSales/UnApproveRequest?projectID=${data.item.id}`)
                                    .then((res) => {
                                        this.items.splice(data.index, 1, res.data[0]);
                                        this.$toast.success("Reject successfully !", "Successful", {
                                            timeout: 3000,
                                        });
                                    })
                                    .catch((err) => {
                                        this.$toast.error(err.response.data, "ERROR", {
                                            timeout: 3000,
                                        });
                                    });
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                            true,
                        ],
                        [
                            "<button>Cancel</button>",
                            function (instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                        ],
                    ],
                });
            }

        },
        lockProject(data) {
            this.itemIdex = this.items.indexOf(data.item);
            if (data.item.pmLock == false || data.item.pmLock == null) {
                //this.$log('abc ' + data.item.pmLock);
                this.item.id = data.item.id;
                this.item.pm_DatePaid = data.item.pm_DatePaid;
                this.modalLock = true;
            } else {
                //this.$log('xyz ' + data.item.pmLock);
                if (data.item.pmLockPaid == true) {
                    this.$toast.error("The project has been paid !", "ERROR", {
                        timeout: 3000,
                    });
                    return;
                }
                this.$toast.question("Do you really want to unlock it?", "Warning", {
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    displayMode: "once",
                    position: "center",
                    buttons: [
                        [
                            "<button><b>Yes</b></button>",
                            (instance, toast) => {
                                axios
                                    .get(`/api/PostSales/UnLockProject?projectId=${data.item.id}`)
                                    .then((res) => {
                                        this.items.splice(this.itemIdex, 1, res.data[0]);
                                        this.$toast.success("Unlock successfully !", "Successful", {
                                            timeout: 3000,
                                        });
                                    })
                                    .catch((err) => {
                                        this.$toast.error(err.response.data, "ERROR", {
                                            timeout: 3000,
                                        });
                                    });
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                            true,
                        ],
                        [
                            "<button>No</button>",
                            function (instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                        ],
                    ],
                });
            }

        },
        onInputUser2(index, list) {
            //this.$log(index);

            if (list[index].typeFrequency == 'Project' && list[index].user != null) {
                list[index].frequency = 1;
            }
            if (list[index].typeFrequency == 'Project' && list[index].user == null) {
                list[index].frequency = null;
            }
            if (index == 1 && list[index].user != null && list[index].groupID == 4) {
                list[2].user = null;
                list[2].frequency = null;
                list[2].notes = "";
            } else if (index == 2 && list[index].user != null && list[index].groupID == 4) {
                list[1].user = null;
                list[1].frequency = null;
                list[1].notes = "";
            }
            if ((list[index].frequency == null || list[index].frequency == '') && list[index].user != null) {
                list[index].frequency = this.item.daysOfShooting.length;
            }
        },
        onInputUser(index, list) {
            // this.$log(index);
            if (list[index].typeFrequency == 'Project' && list[index].user != null) {
                list[index].frequency = 1;
            }
            if (list[index].typeFrequency == 'Project' && list[index].user == null) {
                list[index].frequency = null;
            }
            var check = list[index].option.find(e => e.id == list[index].user);
            list[index].company = check.company;
            this.onChangeCompany(index, list);
            if ((list[index].frequency == null || list[index].frequency == '') && list[index].user != null) {
                list[index].frequency = this.item.daysOfShooting.length;
            }
        },
        onChangeCompany(index, list) {
            //this.$log(list);
            if (list[index].company == "All") {
                list[index].option = this.SuggestEmployees.filter(e => (e.position == list[index].role || (list[index].role2 != null && e.position == list[index].role2)));
            } else {
                list[index].option = this.SuggestEmployees.filter(e => (e.position == list[index].role || (list[index].role2 != null && e.position == list[index].role2)) && e.company == list[index].company);
            }

            var check = list[index].option.find(e => e.id == list[index].user);
            if (check == null) {
                list[index].user = null;
            }

        },
        returnOption(index) {
            return this.item.employee1[index].option;
        },
        updateProduction() {
            //this.$log("updateProduction");
            this.item.EP = null;
            this.item.PM = null;
            if (this.item.productionHouse.length > 0) {
                //this.optionPM = this.SuggestEmployees.filter(e => e.position == 'PM' && e.company == this.item.productionHouse);
                this.optionEP = this.SuggestEmployees.filter(e => e.position == 'EP' && e.company == this.item.productionHouse);

            }
        },
        queryItem() {
            let query = Object.assign({}, this.$route.query);
            this.currentPage = 1;
            query.search = this.search;
            query.status = this.searchBonus.status;
            query.productionHouse = this.searchBonus.productionHouse;
            query.approveBy = this.searchBonus.approveBy;
            if (this.searchBonus.to != null && this.searchBonus.from != null) {
                this.$log(this.searchBonus.to);
                this.$log(this.searchBonus.from);
                query.to = this.convert_date_string(this.searchBonus.to);
                query.from = this.convert_date_string(this.searchBonus.from);
            }

            //this.item = null;
            this.$router.push({ query: query });
        },
        convert_date_string(date) {
            if (date == null) return null;
            if (date == '') return null;
            return this.$moment(date)
                .format("YYYY/MM/DD")
                .toString();
        },
        deleteItem(data) {
            this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
                timeout: 20000,
                close: false,
                overlay: true,
                displayMode: "once",
                position: "center",
                buttons: [
                    [
                        "<button><b>Có</b></button>",
                        (instance, toast) => {
                            axios
                                .delete(`/api/Bonus/deletePosition?id=${data.item.id}&deleteBy=${this.$store.state.auth.accountId}`)
                                .then((res) => {
                                    this.items.splice(data.index, 1);
                                    this.$toast.success("Deleted successfully !", "Successful", {
                                        timeout: 3000,
                                    });
                                })
                                .catch((err) => {
                                    this.$toast.error(err.response.data, "ERROR", {
                                        timeout: 3000,
                                    });
                                });
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                        true,
                    ],
                    [
                        "<button>Không</button>",
                        function (instance, toast) {
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                    ],
                ],
            });
        },
    },
};
</script>
<style>
#app .custom-table .thead-light th {
    color: #fff;
    background-color: #343a40;
    border-color: #fff;
}

.custom-pre {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    white-space: pre-wrap;
}
</style>